module.exports = __webpack_public_path__ + "assets/fonts/iconfont.8f02ac0a.eot";